import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from '../fonts/vfs_fonts'
import pdfFontsStandard from 'pdfmake/build/vfs_fonts'

pdfMake.addVirtualFileSystem({ ...pdfFontsStandard, ...pdfFonts.pdfMake.vfs })
pdfMake.fonts = {
  Belleza: { normal: 'Belleza-Regular.ttf' },
  AlexBrush: { normal: 'AlexBrush-Regular.ttf' },
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf',
  },
}

export default pdfMake
